export default "select p.grantee, p.privilege_type, p.is_grantable\nfrom information_schema.cluster_privileges p\nwhere p.cluster_name = {{id}}\n"